export const parseIdProp = (id) => {
    const parts = id.split('_');
    return {
        pinboardId: parts[1],
        tabId: parts[2],
    };
};
//# sourceMappingURL=common.js.map